<template>
  <div>
    <div style="margin-top: 2rem">
      <queryResultTable :queryResultTableItems="queryResultTableItems" :dateHour="true" />
    </div>
    <div class="text-end my-3">
      <exportCsv :exportData="exportValue" :exportDataTitle="paramFields.map((item) => item.label)"
        :exportFileName="exportFileName()" />
    </div>
    <template v-if="paramFields.length != 0 && paramItems.length != 0">
      <div class="ht-work-value-div table-responsive mx-0">
        <table class="ht-work-value-table">
          <thead class="sticky-thead">
            <tr>
              <th v-for="paramField in paramFields" :class="paramField.class" style="
                  min-width: 30px;
                  font-size: 1rem;
                  color: #fff;
                  border: 1px solid #000;
                ">
                {{ paramField.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="paramItem in paramItems">
              <tr>
                <td rowspan="2">{{ paramItem.time }}</td>
                <td>設定值</td>
                <td v-for="setValue in paramItem.value.set">
                  {{ setValue }}
                </td>
              </tr>
              <tr style="color: #4b8c80">
                <td>實際值</td>
                <td v-for="(actValue, act) in paramItem.value.act">
                  {{ actValue }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import queryResultTable from "@/components/queryResultTable.vue";
import exportCsv from "@/components/exportCsv.vue";
import { ref } from "@vue/reactivity";
import { watch } from "@vue/runtime-core";
export default {
  components: { queryResultTable, exportCsv },
  props: {
    inquireData: Object,
  },
  setup(props) {
    const deviceName = ref();
    // const tableHistoryData = ref();
    const queryResultTableItems = ref([]);

    const resultItems = ref([]);

    //熱處理參數table
    const paramFields = ref([]);
    const paramItems = ref([]);

    //匯出資料
    const exportValue = ref([]);

    //設置熱處理相關資料
    const setHtData = (htData) => {
      if (htData.information != undefined) {
        queryResultTableItems.value = [
          {
            date: htData.information[0].date,
            time: htData.information[0].time,
            site: htData.information[0].factory,
            oper: htData.information[0].process,
            group: htData.information[0].group,
            device: htData.information[0].device,
          },
        ];
        deviceName.value = htData.information[0].device;
      } else {
        queryResultTableItems.value = [];
        deviceName.value = "";
      }
      if (htData.htWorkValueFields != undefined) {
        paramFields.value = htData.htWorkValueFields;
      } else {
        paramFields.value = [];
      }
      if (htData.value != undefined) {
        paramItems.value = htData.value;
      } else {
        paramItems.value = [];
      }

      let setValue = {};
      let actValue = {};
      paramItems.value.forEach((element) => {
        setValue = { time: element.time, group: "設定值" };
        setValue = Object.assign(setValue, element.value.set);
        exportValue.value.push(setValue);

        actValue = { time: element.time, group: "實際值" };
        actValue = Object.assign(actValue, element.value.act);
        exportValue.value.push(actValue);
      });
    };

    //匯出資料的檔案名稱
    const exportFileName = () => {
      let exportFileName = "";
      if (deviceName.value != "") {
        exportFileName =
          "熱處理參數_" +
          deviceName.value +
          "_" +
          new Date().getFullYear() +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          ("0" + new Date().getDate()).slice(-2);
      }
      return exportFileName;
    };

    watch(
      () => props.inquireData,
      (newValue) => {
        console.log(newValue);
        setHtData(newValue);
        // htWorkDataRef.value = newValue;
        // orgHeatData();
      },
      { deep: true }
    );

    return {
      queryResultTableItems,
      paramFields,
      paramItems,
      exportValue,
      exportFileName,
    };
  },
};
</script>

<style scoped>
.ht-work-value-div {
  overflow-y: auto;
  height: 450px;
  /* width: 100%; */
  /* min-width: 900px; */
}

.ht-work-value-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #000;
}

.ht-work-value-table>thead>tr>th {
  padding: 5px;
  font-size: 1rem;
  color: #fff;
  background-color: #4b8c80;
  border: 0.1px solid #000;
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-rl;
  text-orientation: upright;
  vertical-align: middle !important;
  min-width: 30px;
}

.sticky-thead {
  position: sticky;
  top: 0px;
}

.ht-work-value-table tbody td {
  border: 0.1px solid black;
}

.ht-act-value-normal {
  background-color: "#fff";
  color: "#4b8c80";
}

.ht-act-value-error {
  background-color: "#c10000";
  color: "#fff";
}

.ht-act-value-warning {
  background-color: "#ffc100";
  color: "#646569";
}
</style>
